import * as constants from "./constants";

const reducer = {
    [constants.ACCOUNT_LIST_LOAD_START]: function (state) {
        return { ...state, isLoading: true };
    },
    [constants.ACCOUNT_LIST_LOAD_SUCCESS]: function (state, action) {
        return {
            ...state,
            data: Array.from(action.data, (x) => {
                return {
                    ...x,
                    lastConnect: !!x.lastConnect ? new Date(x.lastConnect) : null,
                };
            }).sort(compare),
            isLoading: false,
        };
    },
    [constants.ACCOUNT_LIST_LOAD_FAIL]: function (state, action) {
        return { ...state, isLoading: true, error: action.error };
    },

    [constants.ACCOUNT_ITEM_REMOVE_START]: function (state) {
        return { ...state, isLoading: true };
    },
    [constants.ACCOUNT_ITEM_REMOVE_SUCCESS]: function (state) {
        return { ...state, isLoading: false, isShouldReload: true };
    },
    [constants.ACCOUNT_ITEM_REMOVE_FAIL]: function (state, action) {
        return { ...state, isLoading: true, error: action.error };
    },
};

export default function (state, action) {
    if (!state || action.type === constants.ACCOUNT_CLEAR_STORE) {
        state = {
            data: [],
            isLoading: false,
        };
    }

    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }

    return state;
}

function compare(a, b) {
    const bandA = a.lastConnect;
    const bandB = b.lastConnect;

    let comparison = 0;
    if (bandA > bandB) {
        comparison = 1;
    } else if (bandA < bandB) {
        comparison = -1;
    }
    return -comparison;
}
